import AssignToUnitModalContainer from "./AssignToUnitModalContainer";

export default AssignToUnitModalContainer;
